import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Container } from '@mui/material';
// components
import {
  MotionContainer,
  varBounceIn,
  varBounceInLeft,
} from '../../components/animate';
import Page from '../../components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(7),
  paddingBottom: theme.spacing(5),
}));

// ----------------------------------------------------------------------

function Page404() {
  const urlBaseImage = process.env.REACT_APP_BASE_NAME;
  return (
    <RootStyle title="404 Página não encontrada | Tecnozap">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 800, margin: 'auto', textAlign: 'center' }}>
            <motion.div variants={varBounceIn}>
              <Box
                component="img"
                src={`${urlBaseImage}/static/icons/Nao verificado.svg`}
                sx={{ height: 280, mx: 'auto', my: { xs: 5, sm: 10 } }}
              />
            </motion.div>

            <motion.div variants={varBounceInLeft}>
              <Typography variant="h3" paragraph sx={{ margin: '35px' }}>
                Desculpe, página não encontrada!
              </Typography>

              <Typography sx={{ color: 'text.secondary', margin: '35px' }}>
                Desculpe, não conseguimos localizar a página que você está
                procurando. Verifique a conexão com a internet ou tente novamente
                mais tarde.
              </Typography>
            </motion.div>

            <Button to="/" size="large" variant="contained" component={RouterLink}>
              início
            </Button>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}

export default Page404;
